<template>
  <a-modal
    v-model:visible="protocolVisible"
    title="自动续费协议"
    :width="width"
    :footer="null"
    @cancel="protocolVisible = false"
  >
    <div class="protocol-content">
      <h3>自动续费服务协议</h3>
      <p>1. 协议生效条件</p>
      <p>本协议是您与我们之间关于自动续费服务的法律协议。当您点击同意或使用本服务时，即表示您已阅读并同意本协议的全部内容。</p>
      <p>2. 自动续费服务内容</p>
      <p>2.1 自动续费服务是指我们为您提供的在订阅期限即将到期时，自动为您续费并扣款的服务。</p>
      <p>2.2 自动续费周期将按照您最初选择的订阅周期执行，例如：月付、季付、年付等。</p>
      <p>3. 费用与扣款</p>
      <p>3.1 自动续费的费用将按照您当前订阅的价格执行，如有价格调整，我们会提前通知您。</p>
      <p>3.2 我们将在订阅期限到期前的12小时内，从您的支付账户中扣除续费费用。</p>
      <p>4. 取消自动续费</p>
      <p>4.1 您可以随时在账户设置中取消自动续费服务。</p>
      <p>4.2 取消后，您的订阅将在当前期限结束后停止，不会再自动续费。</p>
      <p>5. 其他条款</p>
      <p>5.1 本协议的最终解释权归我们所有。</p>
      <p>5.2 我们有权根据业务需要修改本协议，修改后的协议将在网站上公布。</p>
      <p>5.3 如您继续使用自动续费服务，即视为您接受修改后的协议。</p>
    </div>
  </a-modal>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: 800
    }
  },
  computed: {
    protocolVisible: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.protocol-content {
  max-height: 500px;
  overflow-y: auto;
  padding: 20px;

  h3 {
    text-align: center;
    margin-bottom: 20px;
    font-weight: bold;
  }

  p {
    margin-bottom: 10px;
    line-height: 1.5;
  }
}

@media screen and (max-width: 768px) {
  .protocol-content {
    max-height: 400px;
    padding: 15px;

    h3 {
      font-size: 16px;
      margin-bottom: 15px;
    }

    p {
      font-size: 14px;
      margin-bottom: 8px;
    }
  }
}
</style>